<template>
  <div class="fixed-bg">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        <!-- Slider -->
        <div id="slider">
          <!-- <h1>
            TRADEBOOK
          </h1> -->
        </div>
        <!-- Slider -->
      </div>
      <div class="col-md-8 light-bg">
        <h1>Research, Monitor, and Act on Municipal Bonds with Confidence</h1>
        <div class="loginWrap">
          <!-- <img src="../../assets/img/brand/drl.png" alt="DRL" /> -->
          <!-- <h3>TRADEBOOK</h3> -->
          <p
            v-if="!isChangePassword"
          >Please enter your username and we will send you an email with a verification code to reset your password.</p>
          <div v-if="isChangePassword" class="alert alert-success" role="alert">
            <i class="fas fa-check-circle"></i>
            A verification code has been sent to your email account.Please enter the code and new password below.
          </div>
          <form v-if="isChangePassword" role="form"  class="d-flex align-items-center justify-content-center flex-column">
            <div class="form-group mb-3 w-50">
              <div class="input-group input-group-merge input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-sign-in-alt" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  class="form-control"
                  type="text"
                  placeholder="Please enter the verification code "
                  v-model="code"
                />
              </div>
            </div>
            <div class="form-group mb-3 w-50">
              <div class="input-group input-group-merge input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  class="form-control"
                  type="password"
                  placeholder="New Password"
                  v-model="newpassword"
                />
              </div>
            </div>
            <div class="form-group w-50">
              <div class="input-group input-group-merge input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  class="form-control"
                  placeholder="Confirm Password"
                  type="password"
                  v-model="confirmpassword"
                />
              </div>
            </div>
            <br />
            <div v-if="error.message" class="alert alert-danger" role="alert">
              <i class="fas fa-exclamation-triangle"></i>
              {{error.message}}
            </div>
            <div class="text-center">
              <button type="submit" class="btn btn-primary my-2" @click="backToLogin">BACK TO LOGIN</button>
              <button type="submit" class="btn btn-primary my-2" @click="reset">
                CHANGE PASSWORD
                <i
                  v-if="!loading"
                  class="fa fa-arrow-circle-right"
                  aria-hidden="true"
                ></i>
                <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
              </button>
            </div>
            <!-- <a href="#" class="text-light">
              <small>Forgot password?</small>
            </a>-->
          </form>
          <form v-if="!isChangePassword" role="form" class="d-flex align-items-center justify-content-center flex-column">
            <div class="form-group mb-3 w-50">
              <div class="input-group input-group-merge input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-user-alt" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  class="form-control"
                  type="text"
                  placeholder="Please enter username "
                  v-model="username"
                />
              </div>
            </div>
            <br />
            <div v-if="error.message" class="alert alert-danger" role="alert">
              <i class="fas fa-exclamation-triangle"></i>
              {{error.message}}
            </div>
            <div class="text-center">
              <button type="submit" class="btn btn-primary my-2" @click="backToLogin">BACK TO LOGIN</button>
              <button type="submit" class="btn btn-primary my-2" @click="sendVerficationCode">
                SEND VERIFICATION CODE
                <i
                  v-if="!loading"
                  class="fa fa-arrow-circle-right"
                  aria-hidden="true"
                ></i>
                <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
              </button>
            </div>
            <!-- <a href="#" class="text-light">
              <small>Forgot password?</small>
            </a>-->
          </form>
        </div>
        <div class="sbFooter">
          <p>Office: <a href="tel:1-281-398-8600">(281) 398-8600</a> | &nbsp; &nbsp; Toll Free: <a href="tel:1-866-664-4040">(866) 664-4040</a> |  &nbsp; &nbsp; Email: <a href="mailto:drl@drlgroup.net">drl@drlgroup.net</a></p>
        </div>
        <div class="loginFooter">
          <p>
    Securities offered through NewEdge Securities, LLC, member FINRA and SIPC. The DRL Group is not a subsidiary or control affiliate of NewEdge Securities, LLC. NewEdge Securities, Inc. has no affiliation to BondDesk Trading LLC or BondTrader Pro, or Tradeweb Direct, Bondpoint, TMC, Market Axess or any ECN.<br><br>
    Do not buy discount bonds based on the Yield-to-Call (YTC). Yield to call (YTC) is not indicative of total return; this yield is valid only if the security is called. Bonds may or may not be called, or be callable on multiple dates or, in other cases, called any date following the first call date, so yield to call is based on the earliest stated call date. Discounted bonds may be subject to capital gains tax. Bonds may be subject to OID (Original Issue Discount). Bonds could also be subject to the DeMinimis Rule, please consult your tax advisor for further clarification. Insured bonds are issued for timely payment of principal and interest only. Insured bonds do not cover potential market loss and are subject to the claims paying ability of the insurance company. Municipal income may be subject to state, local, and Alternative Minimum Tax (AMT) taxation. Corporate and Municipal securities are subject to gains/losses based on the level of interest rates, market conditions, and credit quality of the issuer. Non-rated (NR), With-Drawn (WR), or below investment grade bonds, and lower-rated bonds carry a greater potential risk of default and should be considered by sophisticated investors only.<br><br>
    Prices and availability may change at any time without notice. The securities described herein may not be eligible for sale in all jurisdictions or to specific categories of investors.<br><br>
    This summary is for informational purposes only and is not an offer or solicitation for the purchase or sale of any security or a recommendation or endorsement of any security or issuer. NewEdge Securities, LLC. and DRL Group make no representation about the accuracy, completeness, or timeliness of this information.<br><br>
    This report does not regard any recipient's specific investment objectives, financial situation, or needs and is based on information obtained from sources believed to be reliable. No independent verification has been made, nor is its accuracy or completeness guaranteed. Opinions expressed herein are subject to change without notice. The division, group, subsidiary, or affiliate of NewEdge Securities, LLC, is under no obligation to update or keep the information current. NewEdge Securities, LLC accepts no liability for any loss or damage of any kind arising out of the use of this report. Contact your tax advisor regarding the suitability of tax-exempt investments in your portfolio. This document is for informational purposes only and does not replace or serve as a substitute for your official monthly statement generated by NFS. Please refer to your official statement for accurate and comprehensive account details.<br><br>
    Reminder: E-mails sent through the internet are not secure. Do not use e-mail to send us personal confidential information. Do not e-mail time sensitive instructions or trade orders. This e-mail is not an official trade confirmation for transactions executed in your account. Your e-mail message is not private; it is subject to review by the firm, its officers, agents, and employees. Unless expressly stated in this e-mail, nothing in this message should be construed as a digital or electronic signature.
</p><br>

<p>
    We take protecting your data and privacy very seriously. You can revoke your consent to receive emails at any time by using the SafeUnsubscribe® link, found at the bottom of every email.
</p><br>

<p>©2026 The DRL Group. All Rights Reserved. <a href=https://www.drlgroup.net/privacy-policy/ target="_blank">Privacy Policy</a></p>

 

<p>Also, here’s an update that adds better spacing for the contact links under the login box:

Office: <a href="tel:1-281-398-8600" style="color: #027fc5;">(281) 398-8600</a> | &nbsp; &nbsp; Toll Free: <a href="tel:1-866-664-4040" style="color: #027fc5;">(866) 664-4040</a> |  &nbsp; &nbsp; Email: <a href="mailto:drl@drlgroup.net" style="color: #027fc5;">drl@drlgroup.net</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";

export default {
  name: "viewdata",
  components: {},
  data() {
    return {
      accessToken: null,
      newpassword: "",
      confirmpassword: "",
      code: "",
      username: "",
      error: {},
      loading: false,
      isChangePassword: false
    };
  },
  created() {},
  methods: {
    backToLogin(e) {
      e.preventDefault();
      this.$router.push("/");
    },
    sendVerficationCode(e) {
      e.preventDefault();
      if (this.username != "") {
        this.loading = true;
        this.error = { message: "" };
        this.$cognitoAuth.forgotPassword(this.username.trim(), err => {
          if (err) {
            //console.log("login error",err);
            this.error = err;
            this.loading = false;
          } else {
            console.log("code sent");
            this.loading = false;
            this.isChangePassword = true;
          }
        });
      } else {
        this.error = {
          message: "Please enter your username"
        };
      }
    },
    setUserLastPasswordReset(){
      let dataToSend = {"username": this.username}
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http.put(config.baseUrlLamda,dataToSend,auth)
      .then(() => {

      })

    },
    reset(e) {
      e.preventDefault();
      this.error = { message: "" };
      if (
        this.newpassword == "" ||
        this.confirmpassword == "" ||
        this.code == ""
      ) {
        this.error = {
          message:
            "New password,verification code and confirm password is required"
        };
        return false;
      }
      if (this.newpassword == this.confirmpassword) {
        this.loading = true;
        this.$cognitoAuth.confirmPassword(
          this.username,
          this.code.trim(),
          this.newpassword,
          err => {
            if (err) {
              //console.log("login error",err);
              if(err.message.includes('Member must satisfy regular expression pattern')){
                 this.error = {
                    message: "Spaces not allowed in the password field"
                  };
              }else{
                this.error = err;

              }
              this.loading = false;
            } else {
              //console.log("code sent");
              this.loading = false;
              this.$alert("Password changed successfully","","success");
              this.setUserLastPasswordReset();
              this.$router.push("/");
            }
          }
        );
      } else {
        this.error = {
          message: "New password and confirm password do not match"
        };
      }
    }
  },
  mounted() {}
};
</script>
<style scoped>
</style>